import { GeneralInfo } from '../../../hoc/individual/types';
import { OrganizationType } from '../../../hoc/common/types';
import AmlGeneralInfoWrapper from './parts/general-info-wrapper';
import AmlGeneralInfoRow from './parts/general-info-row';
import { AmlGeneralInfoTypes } from './types';

const AmlGeneralInfo = ({
  clientsActivities,
  type,
  isLoading,
  nextReviewDate,
  auditLogAllowed,
  setChangeLogPanelIsOpen,
  baseInformation,
}: AmlGeneralInfoTypes) => {
  let content;

  if (type === OrganizationType.INDIVIDUAL) {
    content = (
      <AmlGeneralInfoWrapper
        title="Employment status"
        isLoading={isLoading}
        nextReviewDate={nextReviewDate}
        auditLogAllowed={auditLogAllowed}
        setChangeLogPanelIsOpen={setChangeLogPanelIsOpen}
      >
        <AmlGeneralInfoRow
          title="Status"
          value={
            clientsActivities?.find(
              (item) =>
                item.value ===
                (baseInformation as Partial<GeneralInfo>)?.clientActivityId,
            )?.name
          }
        />
      </AmlGeneralInfoWrapper>
    );
  } else if (type === OrganizationType.CORPORATE) {
    content = (
      <AmlGeneralInfoWrapper
        isLoading={isLoading}
        nextReviewDate={nextReviewDate}
        auditLogAllowed={auditLogAllowed}
        setChangeLogPanelIsOpen={setChangeLogPanelIsOpen}
      >
        <div />
      </AmlGeneralInfoWrapper>
    );
  }

  return content;
};

export default AmlGeneralInfo;
